<template>
	<Row class="overflow-hidden">
		<ProjectMenu
			:selectedTabIndex="0"
			class="max-w-[300px] min-w-[300px] overflow-y-auto py-7 px-3 border-r border-[#dfe4ef] menu-container"
		/>
		<router-view class="width-100 px-[3%]" :key="routeNameAndParams"></router-view>
	</Row>
</template>

<script>
import ProjectMenu from '@/components/ProjectMenu/ProjectMenu.vue';
export default {
	name: 'SpaceTeamFeaturesDataProvider',
	components: { ProjectMenu },
	props: {
		idsToShow: { type: Array },
		page: { type: Number, default: 1 },
		featureType: { type: [String, Array] },
	},
	computed: {
		routeNameAndParams() {
			return JSON.stringify({ name: this.$route.name, params: this.$route.params });
		},
	},
};
</script>
<style scoped lang="scss">
.menu-container {
	::v-deep {
		.menu-inner-content-container {
			max-height: calc(100% - 20px);
		}
	}
}
</style>
